// @codekit-prepend "vendor/jquery-2.1.3.min.js"
// @codekit-prepend "vendor/jquery.tooltipster.min.js"
// @codekit-prepend "vendor/scrollit.min.js"
// @codekit-prepend "vendor/scrollReveal.min.js"
// @codekit-prepend "../../../lib/fn-kirby-toolbox/javascript/helpers.js""
// @codekit-prepend "../../../lib/fn-kirby-toolbox/javascript/analytics.js""
// @codekit-prepend "../../../lib/fn-kirby-toolbox/javascript/social-sharing.js""
// @codekit-prepend "../../../lib/fn-kirby-toolbox/javascript/remote-request.js""


if(typeof FN == 'undefined') FN = {};

FN.config = {
  urls: {
    newsletter: 'https://www.git-tower.com/api/contacts/subscribe',
    apiBase: 'https://www.git-tower.com/api/',
    apiContactSubscribe: 'contacts/subscribe',
    apiContactUpdate: 'contacts/update'
  },
  analytics: {
    siteID: 'tower-blog',
    addPlatformToEventLabel: false
  }
};



$(document).ready(function(){

  /*********** Configure Analytics Event Tracking */
  var micrositeAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.section-wrap--signup-follow .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'microsite/footer' }
    },
    /* Social Follow */
    { 'config': { 'selector': '.section-wrap--signup-follow .button-social--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'follow', 'eventLabelSuffix': 'microsite/twitter' }
    },
    /* Page Links */
    { 'config': { 'selector': '.section-container--about-us .button.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'microsite/footer/tower-website' }
    },
    { 'config': { 'selector': '.header-branding .tower-site-link.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'microsite/header/tower-website' }
    },
    /* Social Share */
    { 'config': { 'selector': '.sidebar__share--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'microsite/sidebar/twitter' }
    },
    { 'config': { 'selector': '.sidebar__share--facebook.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'microsite/sidebar/facebook' }
    },
    { 'config': { 'selector': '.sidebar__share--linkedin.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'microsite/sidebar/linkedin' }
    }
  ];
  FN.analytics.addConfiguredEvents(micrositeAnalyticsEvents);


  /*********** prefill "source[OS]" value in newsletter forms */
  if($('input[name="signup[OS]"]').length > 0){
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }

  /*********** newsletter subscription */
  $('.newsletter-form').on('submit', function(event){
    var requestData = $(this).serialize();
    var messageContainer = $(this).find('.request-notice');
    var requestURL = FN.config.urls.newsletter;
    FN.remoteRequest.sendRequest(requestURL, requestData, {'responseContainer':messageContainer});
    event.preventDefault();
  });

  $.scrollIt({
    upKey: 38,             // key code to navigate to the next section
    downKey: 40,           // key code to navigate to the previous section
    easing: 'linear',      // the easing function for animation
    scrollTime: 300,       // how long (in ms) the animation takes
    activeClass: 'sidebar__nav-item--active', // class given to the active nav element
    onPageChange: null,    // function(pageIndex) that is called when page is changed
  });

  $('.sidebar > ul > li > a').tooltipster({
    position: 'left',
    delay: '0'
  });

  $(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 650) {
      $('.sidebar').removeClass('hide-tablet');
    } else {
      $('.sidebar').addClass('hide-tablet');
    }
  });

});
